import { Snackbar } from '@mui/material';
import React from 'react';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';

export function CopyButton(props: any) {
    const [open, setOpen] = React.useState(false);

    const handleClick = () => {
        navigator.clipboard.writeText(props.text)
            .then(() => {
                setOpen(true)
            })
            .catch(() => {
                console.log("Something went wrong!");
            });
    };
    const handleClose = (
        event: React.SyntheticEvent | React.MouseEvent,
        reason?: string,
    ) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    return (
        <div>
            <button onClick={handleClick}>
                <FileCopyOutlinedIcon 
                    sx={{
                        marginLeft: 1,
                        width: 14,
                        height: 14,
                    }}
                />
            </button>

            <Snackbar
                open={open}
                autoHideDuration={3000}
                onClose={handleClose}
                message="Copied"
            />
        </div>
    )
}